import { render, staticRenderFns } from "./SystemMessageUserList.vue?vue&type=template&id=755e4817&"
import script from "./SystemMessageUserList.vue?vue&type=script&lang=js&"
export * from "./SystemMessageUserList.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessageUserList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports